'use strict';

Object.defineProperty(exports, "__esModule", { value: true });
exports.UnknownError = void 0;
var tslib_1 = require("tslib");
var genericError_js_1 = require("./genericError.js");
/**
 * Ошибка "Неизвестная ошибка". Должна использоваться в исключительных случаях:
 *
 * @example
 * eventEmmitter.on('UncaughtException', () => {
 *  throw new UnknownError({ message: 'Event Emmitter uncaught exception!', domain: 'EventEmmiter#handler' });
 * });
 *
 * @export
 * @class UnknownError
 * @extends {GenericError}
 */
var UnknownError = /** @class */ (function (_super) {
    tslib_1.__extends(UnknownError, _super);
    function UnknownError(_a) {
        var message = _a.message, domain = _a.domain, details = _a.details;
        var _this = _super.call(this, {
            type: 'UnknownError',
            message: message,
            domain: domain,
            details: details,
        }) || this;
        Object.setPrototypeOf(_this, UnknownError.prototype);
        if (Error.captureStackTrace) {
            Error.captureStackTrace(_this, UnknownError);
        }
        else {
            _this.stack = new Error().stack;
        }
        return _this;
    }
    return UnknownError;
}(genericError_js_1.GenericError));
exports.UnknownError = UnknownError;
//# sourceMappingURL=unknownError.js.map
